module.exports = __webpack_public_path__ + "img/avatar.4d960d8c.png";